import React, { useState } from 'react';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { distillProductType, toggleDisplayNameForDevices } from 'common/utils/helpers';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import { CustomLabel } from 'components/shared/CustomLabel/CustomLabel';
import { IconLoader } from 'common/IconLoader';
import './SoftwareDownloadModal.css';

export const BulkSoftwareDownloadModalIdCell = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className="BulkSoftwareDownloadModal_DeviceTable_IdCell"
      title={props.targetDeviceDisplay}
      key={Math.random() * 10}
    >
      <div className="BulkSoftwareDownloadModal_DeviceTable_IdCell_DefaultSection">
        {props.hasCheckbox && (
          <Checkbox
            isChecked={props.isChecked}
            onChange={(event) => {
              //selected: on onChange event, if the target selectedDevices is
              const selected = !props.isChecked;
              props.sendSelected(selected, props.targetDeviceId);

              event.stopPropagation(); //stop default row click stuff from happening
            }}
          />
        )}
        <span className="BulkSoftwareDownloadModal_DeviceTable_IdCell_DeviceIdString">{props.targetDeviceDisplay}</span>
        {props.type === 'pivot' && (
          <SvgAF
            customClass={'BulkSoftwareDownloadModal_DeviceTable_IdCell_CollapseIcon'}
            img={isExpanded ? IconLoader.icon_collapseunits : IconLoader.icon_expandunits}
            hover={isExpanded ? IconLoader.icon_collapseunits_hover : IconLoader.icon_expandunits_hover}
            onClick={() => {
              setIsExpanded(!isExpanded);
            }}
          />
        )}
      </div>

      {props.type === 'pivot' && isExpanded && (
        <div className="BulkSoftwareDownloadModal_DeviceTable_IdCell_DetailsSection">
          {props.bundleMembers.map((m, idx) => {
            const memberDisplayName = toggleDisplayNameForDevices(m, props.displayType);
            return (
              <CustomLabel
                img={
                  distillProductType(m.productType ? m.productType : m.properties?.reported?.productType) === 'donor'
                    ? IconLoader.icon_donor
                    : IconLoader.icon_service
                }
                text={memberDisplayName}
                key={idx}
              />
            );
          })}
        </div>
      )}
    </div>
  );
  // }
};
